import React, { useState } from "react";
import { 
  Sparkles, 
  Zap, 
  Palette, 
  Share2, 
  Star, 
  CheckCircle, 
  Users, 
  ArrowRight 
} from "lucide-react";
import movie from "./public/videoai.mp4";
const BhramAiLandingPage = () => {
  const [email, setEmail] = useState("");
  
  const handleEmailSubmit = (e) => {
    e.preventDefault();
    window.open(`https://rzp.io/rzp/4bDB6Wt`,"_blank");
    
  };
  const emailMe = (e) => {
   alert("Email on mridulshukla037@gmail.com")
    
  };

  return (
    <div  className="text-white min-h-screen min-h-screen bg-black text-white overflow-x-hidden">
      {/* Navigation */}
      <header className="fixed w-full z-50 top-0 bg-black/40 backdrop-blur-md">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <Sparkles className="h-8 w-8 text-purple-500 animate-pulse" />
            <h1 className="text-2xl font-bold tracking-tight">BhramAI</h1>
          </div>
          <nav>
            <ul className="flex space-x-6 items-center">
              <li><a href="#features" className="hover:text-purple-400 transition">Features</a></li>
              <li><a href="#pricing" className="hover:text-purple-400 transition">Pricing</a></li>
              <li>
                <a 
                  href="#" 
                  className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded-full transition"
                >
                  Login
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative container mx-auto px-4 pt-32 pb-16 text-center">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 to-black opacity-50 -z-10"></div>
        
        <div className="max-w-4xl mx-auto">
          <span className="inline-block bg-purple-900/30 px-4 py-1.5 rounded-full text-sm mb-4">
            🚀 AI Image Generation is Here
          </span>
          
          <h2 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
            Transform Words into <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-pink-500">
              Visual Masterpieces
            </span>
          </h2>
          
          <p className="text-xl  mb-8 max-w-2xl mx-auto">
            Generate stunning, unique images from text descriptions using cutting-edge AI technology. Unleash your creativity in seconds.
          </p>
          
          <form 
            onSubmit={handleEmailSubmit} 
            className="flex max-w-lg mx-auto space-x-2"
          >
            <input 
              type="email" 
              placeholder="Enter your email" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-grow px-4 py-3  rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <button 
              type="submit" 
              className="bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg flex items-center space-x-2 transition"
            >
              <span>Start </span>
              <ArrowRight className="h-5 w-5" />
            </button>
          </form>
          
          <div className="mt-8 flex justify-center items-center space-x-4">
            {/* <div className="flex -space-x-3">
              {[1, 2, 3, 4, 5].map((user) => (
                <img 
                  key={user} 
                  src={`/api/placeholder/40/40?text=${user}`} 
                  alt="User" 
                  className="w-10 h-10 rounded-full border-2 border-gray-800"
                />
              ))}
            </div> */}
            <div className="flex items-center space-x-2">
              <Star className="text-yellow-400 fill-yellow-400 h-5 w-5" />
              <span className="text-gray-300">5.0 (200+ Reviews)</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h3 className="text-4xl font-bold mb-4">Why Choose BhramAI?</h3>
          <p className="text-xl  max-w-2xl mx-auto">
            Experience the future of image generation with features that set us apart.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <Zap className="h-12 w-12 text-yellow-400" />,
              title: "Ultra-Fast Generation",
              description: "Generate high-quality images in under 5 seconds with our advanced AI."
            },
            {
              icon: <Palette className="h-12 w-12 text-green-400" />,
              title: "Unlimited Creativity",
              description: "Explore endless possibilities with our diverse and powerful AI models."
            },
            {
              icon: <Share2 className="h-12 w-12 text-blue-400" />,
              title: "Easy Sharing",
              description: "Instantly share your creations on social media or download in high resolution."
            }
          ].map((feature, index) => (
            <div 
              key={index} 
              className="bg-gray-900 p-6 rounded-xl border border-gray-800 hover:border-purple-600 transition"
            >
              <div className="mb-4">{feature.icon}</div>
              <h4 className="text-xl font-semibold mb-3">{feature.title}</h4>
              <p className="text-blue-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
<div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
      <video width="900px" 
           height="600px" controls>
       <source src={movie} type="video/mp4"/>
        </video>

        </div>

      {/* Pricing Section */}
      <section id="pricing" className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h3 className="text-4xl font-bold mb-4">Simple, Transparent Pricing</h3>
          <p className="text-xl max-w-2xl mx-auto">
            Choose the plan that fits your creative needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {[
            {
              title: "Pro Creator",
              price: "$5.9",
              features: [
                "Unlimited Image Generations",
                "High Resolution Output",
                "Advanced Editing Tools",
                "Priority Support"
              ],
              cta: "Upgrade to Pro"
            },
            {
              title: "Enterprise",
              price: "Custom",
              features: [
                "Unlimited Enterprise Usage",
                "Custom AI Model Training",
                "Dedicated Account Manager",
                "API Access"
              ],
              cta: "Contact Sales"
            }
          ].map((plan, index) => (
            <div 
              key={index} 
              className="bg-gray-900 p-6 rounded-xl border border-gray-800 hover:border-purple-600 transition"
            >
              <h4 className="text-2xl font-bold mb-4">{plan.title}</h4>
              <div className="text-4xl font-extrabold mb-6">{plan.price}</div>
              
              <ul className="mb-6 space-y-3">
                {plan.features.map((feature, featureIndex) => (
                  <li 
                    key={featureIndex} 
                    className="flex items-center space-x-2"
                  >
                    <CheckCircle className="h-5 w-5 text-green-500" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button onClick={ (plan.cta==="Upgrade to Pro") ? handleEmailSubmit:emailMe} className="w-full bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg transition" style={{backgroundColor:"tomato"}}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Social Proof */}
      <section className="container mx-auto px-4 py-16 text-center">
        <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 p-12 rounded-xl">
          <Users className="h-12 w-12 mx-auto text-purple-400 mb-4" />
          <h3 className="text-3xl font-bold mb-4">Trusted by Creators Worldwide</h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            Join thousands of artists, designers, and content creators who are revolutionizing their workflow with BhramAI.
          </p>
          <div className="flex justify-center space-x-8 opacity-70">
            {['Adobe', 'Figma', 'Canva', 'Creative Market'].map((brand, index) => (
              <span key={index} className="text-xl font-semibold">{brand}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center space-x-6 mb-6">
            {['Privacy', 'Terms', 'Contact', 'FAQ'].map((link, index) => (
              <a 
                key={index} 
                href="#" 
                className="text-gray-400 hover:text-white transition"
              >
                {link}
              </a>
            ))}
          </div>
          <p className="text-white-500">&copy; 2024 BhramAI. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default BhramAiLandingPage;